import { cva } from '@/styled-system/css';

export const popoverContentRecipe = cva({
  base: {
    display: 'flex',
    borderRadius: 'Popover.Content',
    flexDirection: 'column',
    backgroundColor: 'Popover.Content.bg',
    filter: 'drop-shadow({shadows.Popover.Content})',
    maxWidth: 'Popover.Content.width.max',
    maxHeight: 'Popover.Content.height.max',
    position: 'relative',
  },
  variants: {
    modal: {
      true: {
        blockSize: 'auto',
        animation: 'zoom-in 0.2s ease-out',
      },
      false: {},
    },
  },
});

export const popoverContentPositionerRecipe = cva({
  variants: {
    modal: {
      true: {
        zIndex: 2,
      },
      false: {
        zIndex: 'popover',
      },
    },
    dividers: {
      true: {},
      false: {},
    },
    tone: {
      neutral: {},
      critical: {},
      info: {},
      success: {},
      warning: {},
    },
  },
  compoundVariants: [
    {
      dividers: true,
      tone: 'critical',
      css: {
        '& [data-c11n-component="Divider"]': {
          backgroundColor: 'Popover.Divider.bg.critical',
        },
      },
    },
    {
      dividers: true,
      tone: 'info',
      css: {
        '& [data-c11n-component="Divider"]': {
          backgroundColor: 'Popover.Divider.bg.info',
        },
      },
    },
    {
      dividers: true,
      tone: 'success',
      css: {
        '& [data-c11n-component="Divider"]': {
          backgroundColor: 'Popover.Divider.bg.success',
        },
      },
    },
    {
      dividers: true,
      tone: 'warning',
      css: {
        '& [data-c11n-component="Divider"]': {
          backgroundColor: 'Popover.Divider.bg.warning',
        },
      },
    },
  ],
});
